export default {
    data() {
        return {
            typeAxeInterventionConst: [
                {label: this.$t('type_axe.section_courante'), value: 'SECTION_COURANTE'},
                {label: this.$t('type_axe.echangeur'), value: 'ECHANGEUR'},
                {label: this.$t('type_axe.bretelle'), value: 'BRETELLE'},
            ],
        }
    },
    methods: {
        displayForTypeAxeInterventionConst(value) {
            let result = this.typeAxeInterventionConst.find(el => el.value === value);
            return result ? result.label : '';
        },
        getTypeAxeInterventionConst() {
            return this.typeAxeInterventionConst;
        }
    }
}